<!--
    @file:时间选择组件
    @props:{arry} initTime 设置一个初始的时间
-->
<template>
    <el-date-picker
        v-model="datetimerange"
        type="datetimerange"
        :picker-options="pickerOptions"
        placeholder="选择时间范围"
        align="right"
        @change="selectTimeChange">
    </el-date-picker>
</template>

<script>
export default {
    name: 'date-picker',
    data () {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick (picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick (picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick (picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            datetimerange: []
        };
    },
    props: ['initTime'],
    methods: {
        selectTimeChange (time) {
            if (time) {
                this.$emit('change', this.datetimerange);
            }
        }
    },
    watch: {
        initTime (val) {
            this.datetimerange = [new Date(val[0]), new Date(val[1])];
        }
    }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.el-date-editor--datetimerange .el-icon-time{
    background-image: url(../../assets/img/date.png);
    background-repeat: no-repeat;
    background-position: center;
}
.el-date-editor--datetimerange .el-icon-time:before{
    visibility: hidden;
}
.el-date-editor--datetimerange .el-input__inner{
    border-color: #9fadc7;
    border-radius: 0;
}
.el-date-editor--datetimerange.el-input{
    width: 100%;
    max-width: 440px;
}
</style>



// WEBPACK FOOTER //
// date-picker.vue?3717c288